import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=489f9ea5&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489f9ea5')) {
      api.createRecord('489f9ea5', component.options)
    } else {
      api.reload('489f9ea5', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=489f9ea5&", function () {
      api.rerender('489f9ea5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SwBIqHg4LGK4/JS/cancellationPolicy.vue"
export default component.exports